/** Allows digits and common phone formatting characters only. */
export const sanitizePhoneInput = (value) => String(value ?? '').replace(/[^\d+\s().-]/g, '');

/**
 * Formats a phone value for display with country code in brackets.
 * e.g. +19298364242 → +1 (929) 836-4242
 */
export const formatPhoneDisplay = (phone) => {
  if (phone == null || phone === '' || phone === '—') return '—';

  const raw = String(phone).trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits) return raw;

  const formatNationalUs = (national) => {
    if (national.length !== 10) return national;
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  };

  const formatWithCountry = (countryCode, national) => {
    const cc = countryCode.replace(/\D/g, '');
    const nat = national.replace(/\D/g, '');
    if (!cc || !nat) return raw;

    if (cc === '1' && nat.length === 10) {
      return `+1 ${formatNationalUs(nat)}`;
    }

    if (nat.length >= 9) {
      return `+${cc} (${nat.slice(0, 3)}) ${nat.slice(3, 6)}-${nat.slice(6)}`;
    }
    if (nat.length >= 6) {
      return `+${cc} (${nat.slice(0, 3)}) ${nat.slice(3)}`;
    }
    return `+${cc} (${nat})`;
  };

  // E.164 with leading +
  if (raw.startsWith('+')) {
    if (digits.length === 11 && digits.startsWith('1')) {
      return formatWithCountry('1', digits.slice(1));
    }
    if (digits.length >= 11 && digits.length <= 13) {
      return formatWithCountry(digits.slice(0, 2), digits.slice(2));
    }
    if (digits.length >= 10) {
      return formatWithCountry(digits.slice(0, 1), digits.slice(1));
    }
  }

  // 10-digit local number — assume US/Canada
  if (digits.length === 10) {
    return `+1 ${formatNationalUs(digits)}`;
  }

  // 11 digits without + — leading 1 treated as US country code
  if (digits.length === 11 && digits.startsWith('1')) {
    return formatWithCountry('1', digits.slice(1));
  }

  if (digits.length > 10) {
    return formatWithCountry(digits.slice(0, 2), digits.slice(2));
  }

  return raw;
};
